const lib = require('./lib');
const dom = require('./dom');
const config = require((typeof DEBUG == "boolean") ? './config.dev.json' : './config.json');

if (new RTCPeerConnection()) {
    lib(window, config.controlHost);
    // Opt-in UI: only renders if the page has an element with id="snowflake".
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => dom(window, lib));
    } else {
        dom(window, lib);
    }
}
